// Scrolling into view active item for nav page

var fn_nav_page = function () {

  // var offset = jQuery(".nav-page__item .is-active").offset();
  // jQuery('.nav-page__wrapper').animate({
  //   scrollLeft: offset.left
  // }, 1000);

  var $nav_page_wrapper = $(".nav-page__wrapper");
  var $nav_page_active = $(".nav-page__item .is-active");
  var $nav_page_active_offset = $($nav_page_active).offset();

  var fn_nav_page_scroll = function () {

    jQuery($nav_page_wrapper).animate({
      scrollLeft: $nav_page_active_offset.left - 20
    }, 480);

  }

  if ($($nav_page_wrapper).length) {
    // do stuff when selector exists
    $(window).on('load resize', function () {
      fn_nav_page_scroll();
    });

  }

};
